<template>
  <div class="content">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <div v-loading="loading">
          <div class="row">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="row">
                    <div class="col-md-6 text-muted">
                      Page {{ storiesPagination.page }} / {{ storiesPagination.pages }}
                      - {{ storiesPagination.total }} élément(s)
                    </div>
                    <div class="col-md-6 text-right">
                      <a :href="`${$env.VUE_APP_API_BASE_URL.replace('/api/1', '')}/rss.xml`" target="_blank" class="btn btn-warning m-r-10">
                        <i class="fa fa-rss"></i>
                        Flux RSS
                      </a>
                      <a href @click.prevent="filters.display = !filters.display; setPage(1)" class="btn btn-info m-r-10">
                        <i class="fa fa-filter"></i>
                        Filtrer
                      </a>
                      <a href @click.prevent="createStory()" class="btn btn-default">
                        <i class="fa fa-plus"></i>
                        Créer un article
                      </a>
                    </div>
                  </div>
                </div>
                <div class="card-body table-responsive">
                  <form
                    class=""
                    @submit.prevent="setPage(1)"
                    v-if="filters.display">
                    <div class="row">
                      <div class="col-md-8">
                        <el-input
                          placeholder="Filtrer par mots clés (titre)"
                          @change="setPage(1)"
                          v-model="filters.term"></el-input>
                      </div>
                      <div class="col-md-4">
                        <el-select
                          @change="setPage(1)"
                          v-model="filters.order_by">
                          <el-option
                            v-for="option in orderOptions"
                            :label="$t(`story.${option}`)"
                            :key="option"
                            :value="option">
                              {{ $t(`story.${option}`) }}
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <el-select
                          clearable
                          @change="setPage(1)"
                          v-model="filters.status">
                          <el-option
                            v-for="item in constants.STORY_STATUSES"
                            :label="$t(`story.${item}`)"
                            :key="item"
                            :value="item">
                              {{ $t(`story.${item}`) }}
                          </el-option>
                        </el-select>
                      </div>
                      <div class="col-md-4">
                        <el-select
                          clearable
                          @change="setPage(1)"
                          v-model="filters.scheme">
                          <el-option
                            v-for="item in constants.STORY_SCHEMES"
                            :label="$t(`story.${item}`)"
                            :key="item"
                            :value="item">
                              {{ $t(`story.${item}`) }}
                          </el-option>
                        </el-select>
                      </div>
                      <div class="col-md-4">
                        <el-select
                          clearable
                          @change="setPage(1)"
                          v-model="filters.scope">
                          <el-option
                            v-for="item in constants.STORY_SCOPES"
                            :label="$t(`story.${item}`)"
                            :key="item"
                            :value="item">
                              {{ $t(`story.${item}`) }}
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                    <div class="form-group">
                      <vue-tags-input
                        placeholder="Filtrer par tags"
                        v-model="tag"
                        :tags="tags"
                        :autocomplete-items="tagsAutocomplete"
                        :add-only-from-autocomplete="true"
                        @tags-changed="TagUpdateItems">
                      <div
                          slot="tag-left"
                          slot-scope="props"
                          class="label"
                          @click="props.performOpenEdit(props.index)">
                          <i class="fa fa-tag"></i>
                        </div>
                      </vue-tags-input>
                    </div>
                    <div class="form-group">
                      <vue-tags-input
                        placeholder="Filtrer par Auteur"
                        v-model="author"
                        :max-tags="1"
                        :tags="authors"
                        :autocomplete-items="AuthorAutocomplete"
                        :add-only-from-autocomplete="true"
                        @tags-changed="AuthorUpdateItems">
                      <div
                          slot="tag-left"
                          slot-scope="props"
                          class="label"
                          @click="props.performOpenEdit(props.index)">
                          <i class="fa fa-tag"></i>
                        </div>
                      </vue-tags-input>
                    </div>
                  </form>
                  <stories
                    :stories="stories"
                    :pagination="storiesPagination"
                    :toStory="toStory"
                    :edit="true"
                    :setPage="setPage"></stories>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!-- <pre>{{ stories }}</pre> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  computed: {
      ...mapGetters({
      globals: 'globals',
      constants: 'constants',
      stories: 'stories',
      story: 'story',
      storiesPagination: 'storiesPagination'
    }),
  },
  components: {
    VueTagsInput,
  },
  data () {
    return {
      loading: false,
      tag: '',
      tags: [],
      tagsAutocomplete: [],
      author: '',
      authors: [],
      AuthorAutocomplete: [],
      debounce: null,
      default_filters: null,
      filters: {
        status: null,
        scheme: null,
        scope: null,
        term: null,
        tags_ids: null,
        author_id: null,
        page: 1,
        per_page: 25,
        order_by: 'CREATED_AT_DESC',
        display: false
      },
      orderOptions: ['CREATED_AT_DESC', 'PUBLISHED_AT_DESC'],
      mask: 'id,slug,title,rich_title,status,thumb_story_list_url,scheme,created_at,' +
      'published_at,primary_category{label,scheme}' +
      'authors{id,screenname}'
    }
  },
  watch: {
    '$route' (to, from) {
      this.filters = Object.assign(this.filters, to.query)
      this.init()
    },
    'tag': 'TagInitItems',
    'author': 'AuthorInitItems',
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.loading = true
      if (this.default_filters === null) {
        this.default_filters = Object.assign({}, this.filters)
      }
      this.filters = Object.assign(this.filters, this.$route.query)
      this.$store.dispatch('getConstants', {
        params: {
          'keys': 'STORY_STATUSES,STORY_SCOPES,STORY_SCHEMES'
        }
      })
      this.$store.dispatch('getStories', {
        params: this.filters,
        headers: { 'x-fields': this.mask }
      }).then(() => {
        this.TagRetoreItems()
        this.AuthorRetoreItems()
        this.loading = false
      })
    },
    createStory () {
      this.$store.dispatch('createStory', {}).then(() => {
        this.$router.replace({
          name: 'story',
          params: {id: this.story.id}
        })
      })
    },
    toStory (storyId, edit) {
      this.$router.push({
        name: 'story',
        params: {id: storyId},
        query: {edit: edit}
      })
    },
    setPage (page) {
      if (this.filters.display === false && this.default_filters) {
        this.filters = Object.assign({}, this.default_filters)
      }
      this.filters.page = page
      this.$router.replace({
        name: 'stories',
        query: Object.assign({}, this.filters)
      })
      window.scrollTo(0,0)
    },
    TagUpdateItems(newTags) {
      this.tagsAutocomplete = [];
      this.tags = newTags;
      this.filters.tags_ids = null
      let tags_ids = []
      this.tags.forEach(v => {
        tags_ids.push(v.id)
      })
      if (tags_ids) {
        this.filters.tags_ids = tags_ids.join(',')
      }
      this.setPage(1)
    },
    TagInitItems() {
      if (this.tag.length < 2) return;
      const url = `/tags/?term=${this.tag}&status=ENABLED&per_page=100`;
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.axios.get(url).then(response => {
          this.tagsAutocomplete = response.data.results.map(t => {
            return {
              text: `${this.$i18n.translate(t.scheme)} | ${t.label}`,
              id: t.id }
          })
        })
      }, 600)
    },
    TagRetoreItems () {
      if (this.tags.length == 0 && this.filters.tags_ids && this.filters.tags_ids.length > 0) {
        this.filters.tags_ids.split(',').forEach(tag_id => {
          if (this.stories.length > 0) {
            this.stories[0].tags.forEach(t => {
              // console.log(tag_id)
              // console.log(JSON.parse(JSON.stringify(t)))
              if (tag_id == t.id) {
                this.tags.push({
                  text: `${this.$i18n.translate(t.scheme)} | ${t.label}`,
                  id: t.id
                })
              }
            })
          }
        })
      }
    },
    AuthorUpdateItems(newAuthors) {
      this.AuthorAutocomplete = [];
      this.authors = newAuthors;
      this.filters.author_id = null
      if (newAuthors.length > 0) {
        this.filters.author_id = newAuthors[0].id
      }
      this.setPage(1)
    },
    AuthorInitItems() {
      if (this.author.length < 2) return;
      const url = `/authors/?term=${this.author}&status=ENABLED&per_page=100`;
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.axios.get(url).then(response => {
          this.AuthorAutocomplete = response.data.results.map(t => {
            return {
              text: `${t.screenname}`,
              id: t.id }
          })
        })
      }, 600)
    },
    AuthorRetoreItems () {
      if (this.author.length == 0 && this.filters.author_id && this.authors.length === 0) {
        this.stories[0].authors.forEach(a => {
          // console.log(this.filters.author_id)
          // console.log(JSON.parse(JSON.stringify(a)))
          if (this.filters.author_id == a.id) {
            this.authors.push({
              text: `${a.screenname}`,
              id: a.id
            })
          }
        })
      }
    }
  }
}
</script>
<style>

.vue-tags-input {
  background: #324652;
  max-width: none !important;
  width: 100% !important;
}

.vue-tags-input .ti-tag {
  color: white;
  font-size: 14px;
  line-height: 1.5;
  position: relative;
  background: #888888;
}

</style>
